import React from "react";
import { Card, CardHeader } from "@opendate-app/setlist";

import ColorSelect from "./ColorSelect";
import SocialMediaInputs from "./SocialMediaInputs";
import LogoSelect from "./LogoSelect";
import FontSelect from "./FontSelect";

const VenueOwnershipForm = () => (
  <>
    <Card header={<CardHeader title="Logo" />}>
      <LogoSelect />
    </Card>
    <Card header={<CardHeader title="Social media" supportingText="Links to your venue's social profiles." />}>
      <SocialMediaInputs />
    </Card>
    <Card>
      <ColorSelect />
    </Card>
    <Card header={<CardHeader title="Font" />}>
      <FontSelect />
    </Card>
  </>
);

export default VenueOwnershipForm;
